import MuiFormHelperText, {
  FormHelperTextProps
} from '@mui/material/FormHelperText';

export interface IFormHelperTextProps extends FormHelperTextProps {}

const FormHelperText = (props: IFormHelperTextProps): JSX.Element => {
  return <MuiFormHelperText {...props} />;
};

export default FormHelperText;
